export default "https://cdn-gra-staging.amplement.io/statics/images/fallback-file-img.svg";